// extracted by css-extract-rspack-plugin
export default {"loader":"nRjE1P","image":"HG30hf","loaded":"xeZe49"};